import styled from 'styled-components';
import theme from '@/data/theme';

const StyledIconWrapper = styled.div`
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  padding: 10px 10px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border: none;
  cursor: pointer;
  max-height: 50px;
  max-width: 50px;
  align-self: center;
`;

const StyledCancelButton = styled.button`
  border: 1px solid #fee2e2;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: ${theme.fonts.fontSizeLg};
  background: none;
  color: ${theme.colors.danger};
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  font-family: ${theme.fonts.primary};
`;

const StyledLogoutButton = styled.button`
  background-color: ${theme.colors.danger};
  padding: 10px 20px;
  border-radius: 8px;
  color: white;
  border: none;
  font-weight: 500;
  font-size: ${theme.fonts.fontSizeLg};
  cursor: pointer;
  width: 100%;
  font-family: ${theme.fonts.primary};
`;

export { StyledCancelButton, StyledLogoutButton, StyledIconWrapper };
